import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsEmail,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
  Min,
  Max
} from 'class-validator';
import {
  MAX_PHYSICAL_CARD_AMOUNT,
  MIN_PHYSICAL_CARD_AMOUNT
} from '../../constants';
import { PaymentDto } from '../payment.dto';
import { GiftCardDto } from './giftCard.dto';
import { GiftCardAddressDto } from './giftCardAddress.dto';
import { GiftCardPromotionDto } from './giftCardPromotion.dto';
import { GiftCardTypeDto } from './giftCardType.dto';

export class GiftCardGeneratePhysicalCardRequestDto {
  @IsNumber() // BD-2775 - number string from card-issue form
  public merchantId: number;

  @IsString()
  @MaxLength(255)
  public customerName: string;

  @IsString()
  @MaxLength(255)
  public customerEmail: string;

  @Type(() => GiftCardTypeDto)
  public giftCardType: GiftCardTypeDto;

  @Type(() => GiftCardAddressDto)
  public giftCardAddress?: GiftCardAddressDto;

  @IsOptional()
  public giftCardId?: number;

  @IsString()
  @IsOptional()
  public customerPhoneNumber?: string;

  @IsBoolean()
  @IsOptional()
  public processed?: boolean;

  @Type(() => PaymentDto)
  @IsOptional()
  payment?: PaymentDto;

  @IsString()
  @IsOptional()
  @MaxLength(140)
  public message?: string;

  @Type(() => GiftCardDto)
  @IsOptional()
  giftCard?: GiftCardDto;

  @IsBoolean()
  @IsOptional()
  public active?: boolean;

  @IsBoolean()
  @IsOptional()
  public acceptsMarketingTerms?: boolean;

  @IsBoolean()
  @IsOptional()
  public acceptTerms?: boolean;

  @IsOptional()
  @Type(() => GiftCardPromotionDto)
  public giftCardPromotion?: GiftCardPromotionDto;

  @IsNumber()
  @Max(MAX_PHYSICAL_CARD_AMOUNT)
  @Min(MIN_PHYSICAL_CARD_AMOUNT)
  public cardValue: number;

  @MaxLength(255)
  fromName: string;

  @MaxLength(255)
  @IsEmail()
  fromEmail: string;

  constructor(
    merchantId: number,
    customerName: string,
    customerEmail: string,
    giftCardType: GiftCardTypeDto,
    giftCardAddress: GiftCardAddressDto,
    cardValue: number,
    fromName?: string,
    fromEmail?: string,
    giftCardId?: number,
    customerPhoneNumber?: string,
    processed?: boolean,
    message?: string,
    payment?: PaymentDto,
    giftCard?: GiftCardDto,
    active?: boolean,
    acceptsMarketingTerms?: boolean,
    acceptTerms?: boolean,
    giftCardPromotion?: GiftCardPromotionDto
  ) {
    this.merchantId = merchantId;
    this.customerName = customerName;
    this.customerEmail = customerEmail;
    this.giftCardType = giftCardType;
    this.giftCardAddress = giftCardAddress;
    this.cardValue = cardValue;
    this.giftCardId = giftCardId;
    this.customerPhoneNumber = customerPhoneNumber;
    this.processed = processed;
    this.message = message;
    this.payment = payment;
    this.giftCard = giftCard;
    this.active = active;
    this.acceptsMarketingTerms = acceptsMarketingTerms;
    this.acceptTerms = acceptTerms;
    this.giftCardPromotion = giftCardPromotion;
    this.fromEmail = fromEmail;
    this.fromName = fromName;
  }
}
